import Toolbar from "./IO/Toolbar/Toolbar";
import Grid from "./IO/Grid/Grid";
import ToolbarShare from "./Share/Toolbar/Toolbar";
import GridShare from "./Share/Grid/Grid";

const FundsConsolidationReports = {
  Grid,
  Toolbar,
  ToolbarShare,
  GridShare,
};

export default FundsConsolidationReports;
